import { Alert, Typography, AlertColor } from '@mui/material';

interface InfoAlertProps {
  children: React.ReactNode;
  severity?: AlertColor;
}

export function InfoAlert({ children, severity = 'info' }: InfoAlertProps) {
  return (
    <Alert severity={severity}>
      <Typography component="div">{children}</Typography>
    </Alert>
  );
}
